import React from 'react';
import PropTypes from 'prop-types';
import withStyles, { css } from '@bd/bdui-styles';
import { userRegister } from '@bd/bdcore-data/build/User/actions';
import withData from '@bd/bdcore-data';
import { BtnAnimationSheen } from './../helpers/UIElements';
import { colors } from '../styles';

const defaultStyles = css`
  label {
    font-weight: 700;
    font-size: 15px;
    color: #000000;
    letter-spacing: 0;
    line-height: 18px;
    @media(min-width: 992px) {
      font-size: 17px;
    }
  }
  .form-row {
    margin: 0 0 15px 0;
    @media(min-width: 576px) {
      margin: 0 0 30px 0;
    }
    .col-sm {
      margin-bottom: 20px;
      @media(min-width: 576px) {
        padding: 0 30px 0 0;
        margin-bottom: 0;
      }
    }
  }
  .FormTitle {
    text-transform: uppercase;
    color: ${colors.color2};
    font-weight: 700;
    font-size: 16px;
    line-height: 25px;
    letter-spacing: 2.53px;
    margin: 40px 0 20px;
    padding: 0 0 15px;
    position: relative;
    @media(min-width: 992px) {
      font-size: 22px;
      line-height: 32px;
      letter-spacing: 4px;
      margin: 20px 0 30px;
      padding: 0 0 20px;
    }
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 75px;
      height: 2px;
      background-color: ${colors.color1};
    }
  }
  input, select, textarea {
    border-radius: 0;
    border-color: #B9B9B9;
    height: 54px;
    cursor: pointer;
    @media(min-width: 992px) {
      height: 64px;
    }
  }
  .FormButton {
    height: 45px;
    padding: 0 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 700;
    font-size: 15px;
    color: #FFFFFF;
    letter-spacing: 0.12px;
    background-color: ${colors.color1};
    cursor: pointer;
    @media(min-width: 992px) {
      height: 55px;
      padding: 0 35px;
      font-size: 17px;
      letter-spacing: 0;
    }
    &:focus {
      outline: none;
    }
  }

`;

class ClientRegister extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleInput = event => {
    const key = event.target.name;
    const value = event.target.value;

    this.setState({
      [key]: value,
    });
  }

  render() {
    const { className, dispatch } = this.props;

    return (
      <div className={className}>
        <form onSubmit={event => { event.preventDefault(); dispatch(userRegister(this.state)); }} >
          <div className="ClientRegister">
            <div className="ClientRegister_formSection">
              <h4 className="FormTitle">Register</h4>
              <div className="form-row">
                <label htmlFor="registerEmail">Email</label>
                <input className="form-control" type="text" name="email" id="registerEmail" onChange={this.handleInput} required />
              </div>
              <div className="form-row">
                <label htmlFor="firstName">First Name</label>
                <input className="form-control" type="text" name="firstName" id="firstName" onChange={this.handleInput} required />
              </div>
              <div className="form-row">
                <label htmlFor="lastName">Last Name</label>
                <input className="form-control" type="text" name="lastName" id="lastName" onChange={this.handleInput} required />
              </div>
              <div className="form-row">
                <label htmlFor="reigsterPassword">Password</label>
                <input className="form-control" type="password" name="password" id="reigsterPassword" onChange={this.handleInput} required />
              </div>
              <div className="form-row">
                <label htmlFor="password">Confirm Password</label>
                <input className="form-control" type="password" name="confirmPassword" id="confirmPassword" onChange={this.handleInput} required />
              </div>
              <div className="form-row">
                <BtnAnimationSheen>
                  <button className="FormButton">Register</button>
                </BtnAnimationSheen>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

ClientRegister.propTypes = {
  className: PropTypes.string,
  dispatch: PropTypes.func.isRequired,
};

ClientRegister.defaultProps = {
  className: undefined,
};

export default withData({})(withStyles(defaultStyles)(ClientRegister));



// WEBPACK FOOTER //
// ./src/bdcoreCandidates/ClientRegister.js